<template>
  <transition name="el-fade-in-linear">
    <!--普通模式样式，直接点击media的弹出-->
    <div class="media-preview-dialog-component" v-if="showModal && !simple">
      <hi-dialog
        v-show="showPreviewModal"
        title="Preview"
        class="preview-dialog"
        @close="showModal = false"
      >
        <template v-if="model.type === 1">
          <div
            v-show="!loading"
            class="image-container"
            :style="{ backgroundImage: `url(${src}` }"
          ></div>
          <div v-show="loading" class="mask-container">
            <img
              src="../../../../public/images/common/image_loading.png"
              class="mask-img"
            />
          </div>
        </template>
        <media-video
          class="image-container"
          v-if="model.type === 2"
          :poster="model.coverUrl"
          :src="model.url"
        ></media-video>
        <div class="bottom-container">
          <!-- <hi-button v-if="twitterUser || facebookUser" @click="menuClick({ id: 'post' })">Schedule</hi-button>
          <button-menu v-else  :model="menus" @click="menuClick">
            <hi-button>Schedule</hi-button>
          </button-menu> -->
          <hi-button @click="menuClick({ id: 'post' })">Schedule</hi-button>
        </div>
      </hi-dialog>
    </div>
    <!--简单模式，通过拖拽弹出的-->
    <div
      class="media-preview-dialog-component"
      @click.stop="showModal = false"
      v-if="showModal && simple"
    >
      <div class="simple-modal">
        <div class="schedule-type-item" @click="menuClick({ id: 'story' })">
          <div class="icon story"></div>
          <div class="text">Story</div>
        </div>
        <div class="schedule-type-item" @click="menuClick({ id: 'post' })">
          <div class="icon post"></div>
          <div class="text">Post</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="less" scoped>
@import "../../../assets/style/theme.less";

.media-preview-dialog-component {
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;

  .preview-dialog {
    min-height: inherit;
  }

  .image-container {
    width: 55vh;
    height: 55vh;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-color: rgb(240, 240, 240);
  }

  .mask-container {
    width: 55vh;
    height: 55vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(240, 240, 240);

    .mask-img {
      width: 50%;
      max-width: 60px;
      display: block;
    }
  }

  .bottom-container {
    padding: 0 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 64px;
  }

  .simple-modal {
    width: 240px;
    height: 134px;
    background-color: #ffffff;
    border-radius: 16px;
    display: flex;
    padding: 15px 30px;
    justify-content: space-between;
    align-items: center;

    .schedule-type-item {
      color: @theme-color;
      cursor: pointer;

      &:hover {
        opacity: 0.7;
      }

      .icon {
        width: 70px;
        height: 70px;
        background-size: contain;

        &.story {
          background-image: url("../../../../public/images/library/Shcedule_Post_Story@3x.png");
        }

        &.post {
          background-image: url("../../../../public/images/library/Shcedule_Post_Post@3x.png");
        }
      }

      .text {
        margin-top: 15px;
        font-size: 15px;
        text-align: center;
        width: 100%;
      }
    }
  }
}
</style>

<script>
import hiDialog from "../../common/dialog/Index.vue";
import hiButton from "../../common/button/Index";
import { mapGetters } from "vuex";
import { CURRENT_PUBLISHER_SIMPLE } from "../../../store/mutation-types";
import { showErrorMsg, initValidate } from "../../../utils/errors";
import MediaVideo from "../../common/media/Video";
import { validateCurrentPublisherStatus } from "../../../service/publisher";

export default {
  name: "MediaPreviewDialogComponent",
  components: { MediaVideo, hiDialog, hiButton },
  data() {
    return {
      loading: true, // 图片地址，图片加载中为空字符串，完全加载完成显示url地址
      showModal: false,
      showFormDialog: false,
      model: {}, // 当前显示的图片
      images: [], // 用户选中的图片
      src: "",
      simple: false, // 是否为简单模式，只是单独显示post 和 story 2个按钮没有图片缩略
      menus: [
        {
          id: "post",
          image: "post",
          text: "Schedule as Post",
        },
        {
          id: "story",
          image: "story",
          text: "Schedule as Story",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      currentPublisher: CURRENT_PUBLISHER_SIMPLE,
    }),
    insUser() {
      return this.currentPublisher.socialNetwork === 1;
    },
    twitterUser() {
      return this.currentPublisher.socialNetwork === 4;
    },
    facebookUser() {
      return (
        this.currentPublisher.socialNetwork === 2 ||
        this.currentPublisher.socialNetwork === 3
      );
    },
    /**
     * 如果显示login则隐藏preview
     */
    showPreviewModal() {
      return !this.showLoginDialog;
    },
  },
  methods: {
    showDownload() {
      this.$bus.$emit("showDownload");
    },
    /**
     * 打開頁面
     */
    open({ medias, simple }) {
      // 验证当前用户是否需要登录，如果需要登录则弹出提示
      if (!validateCurrentPublisherStatus()) {
        return;
      }
      this.showLoginDialog = false;
      console.log(medias, simple);
      this.model = medias[0];
      this.images = medias;
      if (!simple) {
        this.showModal = true;
      }
      this.loading = true;
      this.simple = simple;
      const img = new Image();
      img.src = this.model.coverUrl;
      img.onload = () => {
        this.src = this.model.url;
        setTimeout(() => {
          this.loading = false;
          // 如果是简单模式则非ins 直接post
          if (simple) {
            // if (!this.insUser) {
            //   this.menuClick({ id: 'post' })
            // } else {
            //   this.showModal = true
            // }
            this.menuClick({ id: "post" });
          }
        }, 300);
      };
      img.onerror = () => {
        this.showModal = false;
        this.loading = false;
      };
    },
    menuClick(item) {
      // 判断当前Publisher状态是否有效
      if (this.currentPublisher.status === 0) {
        if (this.currentPublisher.socialNetwork === 1) {
          // member则弹提示
          if (this.currentPublisher.isMember) {
            this.$alert.show(`Ask Admin to open Apphi and verify for you.`);
          } else {
            showErrorMsg(
              initValidate({
                msg: "Some accounts below cannot auto post. Must login to verify for schedules.",
              })
            );
            // 是自己账号让他重新登录
            this.$bus.$emit("showAddIns", {
              username: this.currentPublisher.username,
              insType: "verify",
            });
          }
        } else if (this.currentPublisher.socialNetwork === 2) {
          this.$bus.$emit("showAddFacebookPage", {});
        } else if (this.currentPublisher.socialNetwork === 3) {
          this.$bus.$emit("showAddFacebookGroup", {});
        } else if (this.currentPublisher.socialNetwork === 4) {
          this.$bus.$emit("showAddTwitter", {});
        }
        return;
      }
      // 获取当前选中人是否为问题账号
      this.showLoginDialog = true;
      const scheduleForm = {
        images: this.images,
        type: "new",
        form: {},
        mediaType: item.id === "story" ? 3 : 1,
        fromType: "schedule",
      };
      // 如果是视频的时候验证一下是否符合发送规范
      if (this.model.type === 2) {
        if (item.id === "story") {
          const msg =
            "Due to Instagram STORY limitations, Apphi Desktop only supports .mp4 video format with ratios between 9:16. Video cannot longer than 15 seconds.\n\nYou can use Apphi App to edit your Story video, schedule and upload directly.";
          if (!this.model.storyVideo) {
            this.$bus.$emit("showDownload", { msg });
            return;
          }
        } else {
          const msg = `Due to Instagram POST limitations, Apphi Desktop only supports .mp4 video format with ratios between 4:5 to 16:9. Video must be between 3 to 60 seconds. \n\nYou can use Apphi App to edit your video, change cover, schedule and upload directly.`;
          if (!this.model.postVideo) {
            this.$bus.$emit("showDownload", { msg });
            return;
          }
        }
      }
      this.$bus.$emit("showScheduleForm", scheduleForm);
      this.showModal = false;
    },
  },
};
</script>
